import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const SID_KEY = "mh_sid_v1";

function getOrCreateSessionId() {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid || sid.length < 12) {
    sid = (crypto?.randomUUID?.() || Math.random().toString(36).slice(2) + Date.now().toString(36));
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

/**
 * Sends an anonymous heartbeat to the backend every 30s + on every route change.
 * Powers the admin's live analytics widget.
 */
export default function useHeartbeat() {
  const { pathname } = useLocation();
  const timerRef = useRef(null);

  useEffect(() => {
    const sid = getOrCreateSessionId();
    const send = () => {
      api.post("/analytics/heartbeat", { session_id: sid, path: pathname }).catch(() => {});
    };
    send(); // immediate ping on mount / route change
    timerRef.current = setInterval(send, 30000);
    return () => timerRef.current && clearInterval(timerRef.current);
  }, [pathname]);
}
